import React, { useState, useEffect } from 'react'
import { Link  } from "react-router-dom"
import './common.css'
import API_URL from '../common/Apiurl';
import SuccessMessage from '../common/Message';

function Addcategory(){
    const apiUrl = API_URL;
    const [items, setItems] = useState([]);
    const [successMessages, setSuccessMessages] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [category, setcategory] = useState("");
    const [industryId, setindustryId] = useState("");
    const [addkey, setaddkey] = useState("");

    useEffect(() => {
      const getComments = async () => {
        try{
          const res = await fetch(`${apiUrl}/industrylist`,{
              method:'GET',
              headers:{
                  "Content-Type":"application/json",
                  "Accept":"application/json"
              },
          });
          const data = await res.json();
          if(data.status !== 200){
            throw new Error('Data not found');
          }
          setItems(data.data);
        }catch(error){
          console.error('Error ', error)
        }
      };
      getComments();
    }, []);

    const clicktoaddcategory = async (e) => {
        e.preventDefault();
        console.log(selectedOptions);
        const postData = {
            category_name: category,
            // industry_id: industryId,
            industry_id: selectedOptions,
            keywords:addkey
        };
        const result = await fetch(`${apiUrl}/createcategory`,{
            method:'POST',
            headers:{
                "Content-Type":"application/json",
                "Accept":"application/json"
            },
            body:JSON.stringify(postData)
        });
        const data = await result.json();
        if((data.status === 200)){
            const newSuccessMessage = data.message;
            setSuccessMessages([...successMessages, newSuccessMessage]);
        }else if((data.status === 400)){
            const newSuccessMessage = data.message;
            setSuccessMessages([...successMessages, newSuccessMessage]);
        }
        setcategory(' ');
        setaddkey(' ');
    }
    const handleSuccessMessageFadeOut = () =>{
        setSuccessMessages((prevMessages) => prevMessages.slice(1));
        window.location.reload();
    }
    const handleOption = (e) => {
        var getValue = (e.target.value);
        if(selectedOptions.includes(getValue)){
            setSelectedOptions(selectedOptions.filter((data)=>data!=getValue));
        }else{
            setSelectedOptions([...selectedOptions, getValue]);
        }
    }
    return (
        <div className='width90'>
            <h2 className='pageTitle'>Add Category</h2>
            <div className='commonCntr'>
                <form className="form-horizontal"  onSubmit={clicktoaddcategory}>
                    <div className="form-group">
                        <label className="control-label col-sm-2 label" htmlFor="categoryname">Category Name:</label>
                        <div className="col-sm-4">
                            <input type="text" onChange={(e)=>setcategory(e.target.value)} className="form-control" id="categoryname" placeholder="Enter Category name" value={category}/>
                        </div>
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label" htmlFor="industrytype">Industry Type:</label>
                        {/* <select multiple class="form-select col-sm-5 selectBox" onChange={(e)=>setindustryId(e.target.value)}>
                            <option value="">Select Industry Name</option>
                            {items.map((item , index) => {
                                return(<option value={item.id}>{item.industry_name}</option>
                            )})}
                        </select> */}
                        <select multiple className="form-select col-sm-5 selectBox" value={selectedOptions} onChange={()=>{}}>
                            <option value="">Select Industry Name</option>
                            {items.map((item , index) => {
                                return(<option value={item.id} onClick={handleOption}>{item.industry_name}</option>
                            )})}
                        </select>
                    </div>
                    <div className="form-group mt-4">
                        <label className="control-label col-sm-2 label" htmlFor="categorykeywords">Add Keywords:</label>
                        <div className="col-sm-4">
                            <input type="text" onChange={(e)=>setaddkey(e.target.value)} className="form-control" id="categorykeywords" placeholder="keyword1, keyword2" value={addkey}/>
                        </div>
                        <span className='d-block mt-2'>Keywords must be comma separated</span>
                    </div>
                    <div className="form-group">
                        <div className="col-sm-offset-2 col-sm-10">
                            <button type="submit" className="btn btn-default submitBtn">Submit</button>
                        </div>
                    </div>
                    {
                        successMessages.map((message, index) => (
                            <SuccessMessage
                                key={index} 
                                message = {message} 
                                onFadeOut={handleSuccessMessageFadeOut}
                            />
                        )
                    )}
                </form>
            </div>
        </div>
    )
}

export default Addcategory;



